import React from "react";

import DashboardCard from "../../../components/admin/dashboard/dashboard-card";

import AdminTemplate from "../../../templates/admin-template";

const AdminDashboardPage = () => {
  return (
    <AdminTemplate>
      <DashboardCard />
    </AdminTemplate>
  );
};

export default AdminDashboardPage;
